import ApiCoreService from "./api.core.service";
import UserService from "./user.service";

export default class SiteService extends ApiCoreService {
  static get token() {
    const token = localStorage.getItem("_token"); // Fetch from localStorage
    return token ? token : null;
  }

  static get userId() {
    const userId = localStorage.getItem("_id"); // Fetch from localStorage
    return userId ? userId : null;
  }

  static async listNodeType() {
    try {
      return await this.graphCall(
        "withAuth.listNodeType",
        `{
     withAuth(token: "${this.token}"){
    listNodeType(criteria:""){
      id
      name{
        str 
      }
        code
    }
  }
}`
      );
    } catch (c) {
      throw new Error(c);
    }
  }

  static async addSite(data, store) {
    try {
      const User = await UserService.getCurrentUser();
      const userNode = store.getters.currentUserNode;
      const cohortIds = userNode.cohorts?.map((c) => c.id);
      //hardwareGroupType
      let hardwareGroupType;
      let hardwareGrpId;
      //get id of hardwareGroupType
      const code=data.nodeType==="residential-house" ? "solar-system" :"solar-plant";
      const groupTypeList =await this.graphCall(
        "withAuth.listNodeHardwareGroupType",
        `{
          withAuth(token:"${this.token}"){
            listNodeHardwareGroupType(criteria:"{\\"code\\":\\"${code}\\"}"){
              id
            }
          }
        }`
      );
    hardwareGroupType=groupTypeList.shift()?.id
    
    //create hardware group for user
    const nodeT=data.nodeType==="residential-house" ? "solar-system" :"Solar farm";
    const nodeHardwareGrp  = await this.graphCall(
      "mutationWithAuth.fabricate.createNodeHardwareGroup",
      `mutation  createNodeHardwareGroup(
                $name: String
                $description: String
                $groupType: String
                $devices:[String]
              )  {
       mutationWithAuth(token:"${this.token}"){
fabricate{
  createNodeHardwareGroup(name:$name,description:$description,groupType:$groupType,devices:$devices){
    id
    name{
      str
    }
  }
}
}
      }`,
      {
        name: `${nodeT} |` + User.name.str,
        description: `${nodeT} |` + User.name.str,
        groupType:hardwareGroupType,
        devices:[]
      }
    );
    hardwareGrpId=nodeHardwareGrp?.id
     //node creation
      return await this.graphCall(
        "mutationWithAuth.fabricate.createNode",
        `mutation  createNode(
                  $name: String
                  $code: String
                  $contactName: String
                  $nodeType:String
                  $organizations:[String]
                  $address: AddressInput
                  $gps: GpsCoordinateInput
                  $phones: [PhoneNumberInput]
                  $emails: [EmailInput]
                  $props: [CustomPropertyInput]
                  $cohorts:[String]
                  $hardwareGroups:[String]
                )  {
          mutationWithAuth(token: "${this.token}") {
            fabricate {
              createNode(
                name: $name
                code: $code
                contactName: $contactName
                nodeType: $nodeType
                organizations: $organizations
                address: $address
                gps: $gps
                phones: $phones
                emails: $emails
                props :$props
                cohorts:$cohorts
                hardwareGroups:$hardwareGroups
              ) {
                id
        name{
          str
        }
        address{
        careOf line1 line2 line3 city state pin 
        country{
        name{str}
        }
        }
        code
        contactName{
          str
        }
        cohorts{
        id
        }
        nodeType{
         id
        }
        hardwareGroups{
          id
          groupType{id name{str} code description{str}} 
          devices{
            id
            uid
            hardwareType{
              id typeName code model{str} description{str} 
                brand{
                            id name{str} code description{str}
                          }
                          category{id name{str} description{str} code}
                          props{prop val propType}
            }
            props{
              prop
              val
              propType
            }
          }
        }
        
              }
            }
          }
        }`,
        {
          name: data.siteName,
          code: this.userId.toString(),
          contactName: User?.name?.str,
          nodeType: data.siteType,
          organizations: [User?.organizations.shift()?.org.id],
          cohorts: cohortIds,
          address: {
            careOf: "",
            line1: data.address,
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: User.address?.country?.id,
            pin: "",
          },
          gps: data.gpsCoordinates,
          phones: User.phones,
          emails: User.emails,
          hardwareGroups:[hardwareGrpId],
          props: [
            {
              prop: "owner",
              val: this.userId.toString(),
              propType: "TEXT",
            },
          ],
        }
      );
    } catch (error) {
      throw new Error(error);
    }
  }

  static async addDevice(data) {
    try {
      let hardwareGroupType;
      let hardwareBrandId;
      let hardwareCategoryId;
      let hardwareTypeId;
      let hardwareDeviceId;
      const siteToAddDevice = JSON.parse(
        localStorage.getItem("siteToAddDevice")
      );
      const User = await UserService.getCurrentUser();
      hardwareGroupType=siteToAddDevice.hardwareGroups[0].groupType?.id
      const hardwareBrand = await this.graphCall(
        "withAuth.listHardwareBrand",
        `{
          withAuth(token:"${this.token}"){
            listHardwareBrand(criteria:"{\\"code\\":\\"${data.inverter?.brand}\\"}"){
              id
            }
          }
        }`
      );
       hardwareBrandId=hardwareBrand.length > 0 ? hardwareBrand?.shift()?.id :'';
      if (hardwareBrand.length == 0) {
        //create brand
       const hardwareBr  = await this.graphCall(
          "mutationWithAuth.fabricate.createHardwareBrand",
          `mutation  createHardwareBrand(
                    $name: String
                    $code: String
                  )  {
           mutationWithAuth(token:"${this.token}"){
    fabricate{
      createHardwareBrand(name:$name,code:$code){
        id
        name{
          str
        }
      }
    }
  }
          }`,
          {
            name: data.inverter?.brand,
            code: data.inverter?.brand,
          }
        );
        hardwareBrandId=hardwareBr?.id;
      }

      const nodeHardwareCategory =await this.graphCall(
        "withAuth.listNodeHardwareCategory",
        `{
          withAuth(token:"${this.token}"){
            listNodeHardwareCategory(criteria:"{\\"code\\":\\"pv-inverter\\"}"){
              id
            }
          }
        }`
      );
      hardwareCategoryId=nodeHardwareCategory.shift()?.id
       
      const code = 'pv-inverter-' + `${data.inverter?.brand || ''} ${data.inverter?.model || ''} ${data.inverter?.capacity || ''}`.replace(/[^a-zA-Z0-9.]/ig, '-').toLowerCase();
      const nodeHardwareType =await this.graphCall(
        "withAuth.listNodeHardwareType",
        `{
          withAuth(token:"${this.token}"){
            listNodeHardwareType(criteria:"{\\"code\\":\\"${code}\\"}"){
              id
            }
          }
        }`
      );
      hardwareTypeId=nodeHardwareType.length > 0 ? nodeHardwareType?.shift()?.id :'';
      if (nodeHardwareType.length == 0) {
        //create hardwareType
       const nodeHardwareTy  = await this.graphCall(
          "mutationWithAuth.fabricate.createNodeHardwareType",
          `mutation  createNodeHardwareType(
                 $typeName: String!
                 $code: String
                 $hardwareBrandId: String
                 $hardwareCategoryId: String
                 $model: String
                 $props: [CustomPropertyInput]
              )
 {
           mutationWithAuth(token:"${this.token}"){
    fabricate{
      createNodeHardwareType(typeName:$typeName,code:$code,model:$model,brand:$hardwareBrandId,category:$hardwareCategoryId,props:$props){
        id
        typeName
      }
    }
  }
          }`,
          {
            typeName: `Solar Inverter ${data.inverter.brand || ''} ${data.inverter.model || ''} ${data.inverter.capacity}KWh`,
            code: 'pv-inverter-' + `${data.inverter.brand || ''} ${data.inverter.model || ''} ${data.inverter?.capacity}KWh`.replace(/[^a-zA-Z0-9.]/ig, '-').toLowerCase(),
            hardwareBrandId:hardwareBrandId,
            hardwareCategoryId:hardwareCategoryId,
            model:data.inverter.model,
            props: [
              {
                prop: "size",
                val: `${data.inverter.capacity}`,
                propType: "TEXT",
              },
            ],
          }
        );
        hardwareTypeId=nodeHardwareTy?.id;
      }
     
      //hardware device
      const hardwareDevice = await this.graphCall(
        "withAuth.listNodeHardwareDevice",
        `{
  withAuth(token:"auto"){
    listNodeHardwareDevice(criteria:"{\\"uid\\":\\"${data.logger.serialNumber}\\"}"){
      id
      uid
    }
  }
}`
      );
      hardwareDeviceId=hardwareDevice.length > 0 ? hardwareDevice?.shift()?.id :'';
      if (hardwareDevice.length === 0) {
       //create hardware device
       const hardwareDev  = await this.graphCall(
        "mutationWithAuth.fabricate.createNodeHardwareDevice",
        `mutation  createNodeHardwareDevice(
                  $uid: String
                  $hardwareType: String
                  $props: [CustomPropertyInput]
                )  {
         mutationWithAuth(token:"${this.token}"){
  fabricate{
    createNodeHardwareDevice(uid:$uid,hardwareType:$hardwareType,props:$props){
      id
    }
  }
}
        }`,
        {
          uid: data.logger?.serialNumber,
          hardwareType: hardwareTypeId,
          props: [
            {
                prop: 'imei',
                val: '',
                propType: 'TEXT'
            },
            {
                prop: 'simNumber',
                val: '',
                propType: 'TEXT'
            }
        ],
        }
      );
      hardwareDeviceId=hardwareDev?.id
      }

      const devices = siteToAddDevice?.hardwareGroups?.[0]?.devices || [];
      const allDevices = [...new Set([hardwareDeviceId, ...devices.map((d) => d.id)])];
      //updating hardwaregroups
      let hardwareGroups = siteToAddDevice.hardwareGroups.map((hg) => hg.id);
      return await this.graphCall(
        "mutationWithAuth.update.updateNodeHardwareGroup",
        `mutation{
         mutationWithAuth(token:"${this.token}"){
              update{
                 updateNodeHardwareGroup(
                     id :"${hardwareGroups[0]}",
                    devices: ${JSON.stringify(
                      allDevices
                    )}              
    ){
      id
    }
    }
  }
}`
      );

     

           
    } catch (c) {
      throw new Error(c);
    }
  }
}
